module.exports = __webpack_public_path__ + "img/fopeaInsultosX3.178d9ead.jpg";